import React from 'react';
import { FlagContent } from './flag-content';
import { FlagLoading } from './flag-loading';
import { FlagError } from './flag-error';
export const UserFlagContent = ({ userFlagProps, loading, error, success, }) => {
    return (React.createElement(React.Fragment, null,
        loading && React.createElement(FlagLoading, null),
        !loading && error && React.createElement(FlagError, null),
        !loading && success && React.createElement(FlagContent, { ...userFlagProps })));
};
//# sourceMappingURL=user-flag-content.js.map